import { Injectable } from '@angular/core';
import { environment } from '../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ConfigService {

  constructor() { }

  public readonly navigationItemsPath = 'assets/navigation-items.json';
  public readonly navigationSubItemsPath = `${environment.serverUrl}/api/v1/getAssignedMenu/`;
  public readonly navigationMastersUrl = `${environment.serverUrl}/api/v1/getAssignMenuById/`;
  public readonly navigationVendorMastersUrl = `${environment.serverUrl}/api/v1/getAllVendorModulesByParents`
  // Add more paths and configurations as needed
}
                                                                                                                                                                                                                                